import { z } from 'zod';
import { ZERO } from '@/constants/common';

export const authTokenSchema = z.object({
  id: z.number().int().gt(ZERO),
  userId: z.number().int().gt(ZERO),
  name: z.string(),
  token: z.string(),
  createdAt: z.string(),
  expirationDate: z.string(),
  active: z.boolean(),
});
